import { EmpresaFilters } from "../../types/empresa";
import { useState } from "react";
import { Filters } from './Filters';
import { UploadEmpresaButton } from '../UtilitiesComponents/UploadEmpresaButton';
import { EmpresasTable } from './EmpresasTable';
import useDebounce from '../../hooks/useDebounce';

export function EmpresasList() {
    const [filtersValues, setFilters] = useState<EmpresaFilters>({
        fechaInicio: "",
        fechaFin: "",
        estado: "",
        prospectador: "",
        frecuenciaVisita: "",
    });

    const filters = useDebounce(filtersValues, 3000);

    return (
        <div className="h-full flex flex-col">
            <div className="flex h-14 p-2 m-2">
                <UploadEmpresaButton />
            </div>

            <div className="flex items-center px-3 py-1">
                <Filters 
                    filters={filters}
                    setFilters={setFilters}/>
            </div>

            <EmpresasTable
                filters={filters} />
        </div>
    );
}